export const GET_STRIPE_PRODUCT = "GET_STRIPE_PRODUCT";
export const GET_STRIPE_PRODUCT_SUCCESS = "GET_STRIPE_PRODUCT_SUCCESS";
export const GET_STRIPE_PRODUCT_ERROR = "GET_STRIPE_PRODUCT_ERROR";

export const CREATE_SUBSCRIPTION = "CREATE_SUBSCRIPTION";
export const CREATE_SUBSCRIPTION_SUCCESS = "CREATE_SUBSCRIPTION_SUCCESS";
export const CREATE_SUBSCRIPTION_ERROR = "CREATE_SUBSCRIPTION_ERROR";
